import { createSlice } from "@reduxjs/toolkit";
import editInvoiceByIdApi from "@custom/rtk-apis/billing/invoice/editInvoiceById";

const initialState = {
  status: "",
  result: null,
  msg: "",
  loading: false,
  error: null,
};

const editInvoiceByIdSlice = createSlice({
  name: "editInvoiceByIdSlice",
  initialState,
  reducers: {
    clearEditUrgency(state) {
      state.status = "";
      state.result = null;
      state.msg = "";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(editInvoiceByIdApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editInvoiceByIdApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload?.status || "success";
        state.result = payload?.result || payload;
        state.msg = payload?.msg || "Invoice updated successfully";
      })
      .addCase(editInvoiceByIdApi.rejected, (state, { payload, error }) => {
        state.loading = false;
        state.status = "error";
        state.error = payload || error.message || "Failed to update invoice";
        state.result = null;
      });
  },
});

export default editInvoiceByIdSlice.reducer;
export const { clearEditUrgency } = editInvoiceByIdSlice.actions;
